import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
  hover?: boolean;
}

export function Card({ children, className = "", padding = true, hover = false }: CardProps) {
  return (
    <div
      className={`bg-[var(--c-surface)] border border-[var(--c-border)] rounded-xl ${padding ? "p-5" : ""} ${
        hover ? "hover:border-[var(--c-border-hover)] transition-all duration-300 ease-out" : ""
      } ${className}`}
      style={{ boxShadow: "var(--c-shadow)" }}
    >
      {children}
    </div>
  );
}

interface StatCardProps {
  title: string;
  value: string;
  subtitle?: string;
  color?: string;
  trend?: "up" | "down" | "neutral";
}

export function StatCard({ title, value, subtitle, color, trend }: StatCardProps) {
  return (
    <Card hover>
      <p
        className="text-[11px] uppercase tracking-widest font-medium mb-2"
        style={{ color: "var(--c-text-secondary)" }}
      >
        {title}
      </p>
      <div className="flex items-baseline gap-2">
        <p
          className="text-2xl font-semibold tracking-tight"
          style={{ color: color || "var(--c-text)" }}
        >
          {value}
        </p>
        {trend && trend !== "neutral" && (
          <span
            className="text-xs font-medium"
            style={{ color: trend === "up" ? "var(--c-success)" : "var(--c-danger)" }}
          >
            {trend === "up" ? "\u2191" : "\u2193"}
          </span>
        )}
      </div>
      {subtitle && (
        <p className="text-xs mt-1.5" style={{ color: "var(--c-text-faint)" }}>
          {subtitle}
        </p>
      )}
    </Card>
  );
}
